<template>
  <div class="download-app-modal">
    <div class="close" @click="close()">
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.22037 1.28002C-0.0734566 0.986194 -0.0734566 0.511071 0.22037 0.22037C0.514196 -0.0703308 0.98932 -0.0734566 1.28002 0.22037L6 4.94035L10.72 0.22037C11.0138 -0.0734566 11.4889 -0.0734566 11.7796 0.22037C12.0703 0.514196 12.0735 0.98932 11.7796 1.28002L7.05965 6L11.7796 10.72C12.0735 11.0138 12.0735 11.4889 11.7796 11.7796C11.4858 12.0703 11.0107 12.0735 10.72 11.7796L6 7.05965L1.28002 11.7796C0.986194 12.0735 0.511071 12.0735 0.22037 11.7796C-0.0703308 11.4858 -0.0734566 11.0107 0.22037 10.72L4.94035 6L0.22037 1.28002Z" fill="white"/>
      </svg>
    </div>

    <div class="download-app-inner">
      <h2>Read better news</h2>
      <p>The best reading experience is in the app. Nourish is available on iOS and Android.</p>

      <div class="qr">
        <NourishQR />
        <div class="tab-callout-marker">
          <span>Scan the QR code and download the right app in no time.</span>
          <svg width="17" height="48" viewBox="0 0 17 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.99544 39.3715C3.3061 37.3956 2.94037 34.4772 0.0812931 32.4453C0.0812931 33.7307 -0.12194 34.4745 0.114274 35.0428C1.63819 38.7088 3.12477 42.4004 4.89337 45.9545C6.06775 48.3146 7.77517 48.6562 9.58405 46.8554C11.9463 44.5038 14.0699 41.8987 16.0898 39.2513C16.8633 38.2374 17.6219 36.8337 16.2068 35.2086C12.9838 36.631 12.004 40.2113 9.16645 42.3331C9.0691 41.672 8.9422 41.2851 8.96677 40.9077C9.47163 33.1737 8.89692 25.4835 8.14069 17.7892C7.68991 13.2026 7.53802 8.58842 7.18336 3.9918C7.10225 2.94057 6.86739 1.85701 6.45026 0.893604C6.25535 0.443527 5.47442 0.0465431 4.92669 0.00115967C4.56144 -0.0291634 3.89929 0.541996 3.78951 0.952045C3.51718 1.96854 3.31565 3.05786 3.38447 4.09898C3.86529 11.3721 4.44034 18.6391 4.94779 25.9106C5.25787 30.3544 5.50145 34.8026 5.77494 39.2488C5.5151 39.2897 5.25528 39.3306 4.99544 39.3715Z" fill="#FFDE00"/>
          </svg>
        </div>
      </div>

      <div class="break-spacer">
        <span class="space-text">or</span>
      </div>

      <div class="button-stack">
        <button @click="goAppStore('ios')">
          <svg width="130" height="155" viewBox="0 0 130 155" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M108.69 81.9089C108.621 69.209 114.354 59.6236 125.959 52.5642C119.466 43.2556 109.657 38.1342 96.7056 37.1306C84.4447 36.1617 71.0441 44.2938 66.1397 44.2938C60.9591 44.2938 49.0781 37.4767 39.7529 37.4767C20.4809 37.7881 0 52.8757 0 83.5699C0 92.6363 1.65781 102.014 4.97344 111.669C9.39426 124.369 25.3507 155.513 41.9979 154.994C50.7014 154.786 56.8491 148.799 68.1775 148.799C79.1605 148.799 84.8592 154.994 94.5643 154.994C111.35 154.751 125.786 126.445 130 113.71C107.481 103.087 108.69 82.5664 108.69 81.9089ZM89.1419 25.0883C98.5707 13.8764 97.7072 3.66808 97.4309 0C89.1073 0.484463 79.4713 5.67514 73.9798 12.077C67.9357 18.9287 64.3783 27.4068 65.1382 36.9576C74.1525 37.6497 82.3725 33.0127 89.1419 25.0883Z" fill="black"/>
          </svg>
          <span>Download for iOS</span>
        </button>
        <button @click="goAppStore('android')">
          <svg width="199" height="113" viewBox="0 0 199 113" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M145.277 67.8039C149.872 67.8039 153.569 71.5211 153.569 76.1414C153.569 80.7618 149.872 84.4789 145.277 84.4789C140.682 84.4789 136.985 80.7618 136.985 76.1414C136.985 71.5211 140.682 67.8039 145.277 67.8039ZM53.6885 67.8039C58.2835 67.8039 61.9802 71.5211 61.9802 76.1414C61.9802 80.7618 58.2835 84.4789 53.6885 84.4789C49.0936 84.4789 45.3969 80.7618 45.3969 76.1414C45.3969 71.5211 49.0936 67.8039 53.6885 67.8039ZM148.248 34.2804L164.797 5.44661C165.073 5.06448 165.246 4.61287 165.315 4.12652C165.384 3.64016 165.384 3.18855 165.281 2.7022C165.177 2.21584 164.97 1.79897 164.693 1.41684C164.417 1.0347 164.071 0.722045 163.657 0.478869C163.242 0.235692 162.793 0.0967362 162.309 0.0272573C161.826 -0.0422216 161.377 0.0272552 160.927 0.166213C160.478 0.305171 160.064 0.548348 159.684 0.826263C159.304 1.10418 159.027 1.52105 158.82 1.93793L142.064 31.1538C128.659 25.1091 114.149 21.9826 99.4654 21.9826C84.7823 21.9826 70.2719 25.1091 56.867 31.1538L40.1455 1.97266C39.9382 1.55579 39.6273 1.17366 39.2818 0.861002C38.9363 0.548347 38.4872 0.339912 38.038 0.200955C37.5889 0.0619968 37.1052 0.0272568 36.6561 0.0619962C36.2069 0.0967357 35.7233 0.270431 35.3087 0.513608C34.8941 0.756784 34.5486 1.06944 34.2722 1.45157C33.9958 1.83371 33.7885 2.28532 33.6849 2.73694C33.5812 3.18855 33.5812 3.6749 33.6503 4.16125C33.7194 4.6476 33.9267 5.06448 34.1686 5.48135L50.7174 34.3151C22.2839 49.8436 2.83299 78.7816 0 113H199C196.167 78.7816 176.716 49.8436 148.248 34.2804Z" fill="black"/>
          </svg>
          <span>Download for Android</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import NourishQR from '@/components/v5/elements/NourishQR.vue';

  export default {
    components: {
      NourishQR,
    },

    methods: {
      close() {
        this.$emit('close');
      },

      goAppStore(type) {
        this.EventBus.$emit('track:event', {
          event: 'invite-get-app',
          props: { mode: `Tapped Store: ${type}` },
          detail: { detail_char: `Tapped Store: ${type}` },
        });

        if (type === 'ios') {
          window.open('https://nourished.news/ios', '_blank');
        }

        if (type === 'android') {
          window.open('https://nourished.news/android', '_blank');
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5.scss';

  .download-app-modal {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 1.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    width: 100%;
    padding: 1.5rem 1.5rem 2.5rem 1.5rem;
    color: white;
    background: black;
    border-top: 1px solid rgba($neutral-400, 0.25);
    border-top-left-radius: 25px;
    border-top-right-radius: 25px;
    max-width: 900px;
    margin: 0 auto;

    .close {
      display: flex;
      align-items: center;
      justify-content: center;
      align-self: flex-end;
      width: 44px;
      height: 44px;
      background: black;
      border: 1px solid rgba($neutral-400, 0.2);
      border-radius: 500px;
      cursor: pointer;
    }

    .download-app-inner {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 1rem;
      padding-bottom: 2.5rem;
      max-width: 500px;
      margin: auto;
      text-align: center;

      

      svg {
        margin-bottom: 1rem;
      }

      h2 {
        font-family: 'Brawler';
        font-size: 2rem;
        font-weight: normal;
      }

      p {
        font-size: 1.1rem;
        text-wrap: balance;
      }
    }

    .qr {
      display: none;
      align-items: center;

      .desktop & {
        display: flex;
      }

      .tab-callout-marker {
        flex-direction: row-reverse;
        align-items: center;
        position: relative;
        gap: 1rem;
        bottom: 0;
        right: 0;
        margin-left: 2rem;
        margin-bottom: 1rem;

        .desktop & {
          bottom: 0;
          right: 0;
        }

        svg {
          transform: rotate(90deg);
          margin: 0;
        }

        span {
          max-width: 200px;
          font-size: 1rem;

          .desktop & {
            font-size: 1rem;
          }
        }
      }
    }

    .break-spacer {
      width: 100%;
      display: none;
      align-items: center;
      margin-bottom: 1.8rem;
      max-width: 400px;

      .desktop & {
        display: flex;
      }

      .space-text {
        display: flex;
        align-items: center;
        width: 100%;
        text-align: center;
        color: rgba($neutral-400, 0.5);

        &::before,
        &::after {
          content: '';
          flex: 1;
          height: 1px;
          margin-top: 2px;
          background-color: rgba($neutral-400,0.5);
        }

        &::before {
          margin-right: 1rem;
        }

        &::after {
          margin-left: 1rem;
        }
      }
    }

    .button-stack {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      gap: 1rem;

      .desktop & {
        flex-direction: row;
        justify-content: center;
      }

      button {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 1rem;
        padding: 1rem;
        width: 100%;

        .desktop & {
          width: auto;
        }

        svg {
          width: 1.5rem;
          height: 1.5rem;
          margin: 0;
        }
      }
    }
  }
</style>    